import { IonIcon } from '@ionic/react';
import { closeCircleOutline } from 'ionicons/icons';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { NoBookmarksContainer } from './bookmarkStyles';

type NoBookmarksProps = {
	listKey: string;
};
const NoBookmarks: React.FC<NoBookmarksProps> = ({ listKey }) => {
	return (
		<>
			<NoBookmarksContainer>
				<IonIcon icon={closeCircleOutline} />
				<p>Uh Oh, looks like you haven’t saved any {listKey} yet</p>
				<NavLink to="/home">Explore</NavLink>
			</NoBookmarksContainer>
		</>
	);
};

export default NoBookmarks;
